import { ProductDocument } from "@omni/types/api/product/bff/shared/productDocument.model";
import { cn } from "@omni/utils/styles";

import { AdditionalServiceComponent } from "@/components/Product/AdditionalService/additionalService.component";
import { TooltipType } from "@/components/Product/ECommerce/eCommerce.types";
import { AdditionalServiceModel } from "@/types/service/shared";

import { formatPriceForEcommerce } from "../../deliveryItem.base";

type AdditionalServiceProps = {
    serviceProduct: AdditionalServiceModel;
    onServiceProductClick: (serviceProduct: AdditionalServiceModel) => void;
    activeServiceProducts: string[];
    tooltip?: TooltipType;
    documents?: Array<ProductDocument>;
};

const AdditionalServiceItem = ({
    serviceProduct,
    onServiceProductClick,
    activeServiceProducts,
    tooltip,
    documents
}: AdditionalServiceProps) => {
    const isActiveProduct = activeServiceProducts.includes(serviceProduct.sku);

    return (
        <div className={cn("tw:flex tw:mt-2 tw:ml-5")}>
            <AdditionalServiceComponent
                additionalService={serviceProduct}
                tooltip={tooltip}
                type={"checkbox"}
                isSelected={isActiveProduct}
                onClick={onServiceProductClick}
                documents={documents}
            />
            <p
                className={cn(
                    "tw:font-bold tw:m-0 tw:text-right tw:whitespace-nowrap"
                )}
            >
                {serviceProduct.price &&
                    formatPriceForEcommerce(serviceProduct.price)}
            </p>
        </div>
    );
};

export { AdditionalServiceItem };
